// extracted by css-extract-rspack-plugin
export default {"assigneeContainer":"assignees-field-module__assigneeContainer__yFFfH"};